module.exports = __webpack_public_path__ + "img/moto.94c24da8.png";